import { render } from "./StatementView.vue?vue&type=template&id=536bd048&scoped=true"
import script from "./StatementView.vue?vue&type=script&lang=js"
export * from "./StatementView.vue?vue&type=script&lang=js"

import "./StatementView.vue?vue&type=style&index=0&id=536bd048&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Katongole R\\Desktop\\Projects\\Portal\\mfuko-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536bd048"]])

export default __exports__